import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
const ContactEnquiryFormSuccessUI = () => {
  const $ = _c(3);
  const successWrapperRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      successWrapperRef?.current?.scrollIntoView({
        block: "center",
        inline: "center"
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center text-gray mt-32 mx-0 mb-40" ref={successWrapperRef}><h1 className="mb-6 text-2xl font-bold">Thank you! We’ve received your request.</h1><p className="mb-6 text-sm">A representative will get back to you in 1-3 business days.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default ContactEnquiryFormSuccessUI;